import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '../../services/api.service';

/**
 * Account security lives on the SSO host, not here — one identity, one place
 * to manage the second factor on it. These two calls are the whole of this
 * Lab's part in getting someone there.
 */
@Injectable({
  providedIn: 'root',
})
export class SsoSecurityService extends ApiService {
  /**
   * Whether to offer the button. False on a Lab running without SSO, and for
   * an account with no SSO identity behind it — a button certain to fail is
   * worse than no button.
   */
  public isAvailable(): Observable<{ available: boolean }> {
    return this.request({
      path: 'sso/security-available',
      method: 'GET',
    });
  }

  /**
   * Where to send the browser. Asked for at the moment of clicking, because
   * the handoff it carries is deliberately short-lived.
   */
  public mfaSetupLink(): Observable<{ url: string }> {
    return this.request({
      path: 'sso/mfa-setup-link',
      method: 'POST',
      body: {},
    });
  }
}
